import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ProjectDeployment from "components/Deployments/ProjectDeployment";

import * as projectReducer from "containers/Project/reducer";
import * as helpReducer from "containers/Help/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as accountsReducer from "containers/Accounts/reducer";

class ProjectDeploymentContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <ProjectDeployment {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { id } = ownProps;

  return {
    goToTableauHelp: () => dispatch(helpReducer.goToTableauIntegrationHelp()),
    goToSalesforceHelp: () => dispatch(helpReducer.goToSalesforceIntegrationHelp()),
    scoreFile: (file) => dispatch(deploymentsReducer.scoreFile(id, file)),
    createDatasetFromMonitor: () => dispatch(deploymentsReducer.createDatasetFromMonitor(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;

  const accountId = projectReducer.getProjectAccountId(state, id);

  return {
    deployment: deploymentsReducer.getProjectDeployment(state, id),
    isScoringFile: projectReducer.getIsScoringFile(state, id),
    accountAPIEndpoint: accountsReducer.getAccountAPIEndpoint(state, accountId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ProjectDeploymentContainer);
